export const handleValidationErrors = (beforeScroll?: () => void) => {
  if (beforeScroll) {
    beforeScroll();
  }

  setTimeout(() => {
    const firstErrorElement = document.querySelector('[role="alert"]');
    if (firstErrorElement) {
      firstErrorElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      const inputElement = firstErrorElement.querySelector('input');
      if (inputElement) {
        inputElement.focus();
      }
    }
  }, 500);
};
